import React, {useEffect} from 'react';
import GraphicUtils from "../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../utils/report-utils.js";

const LineChartContent = ({ data, elementId, elementName, title, divisor = true }) => {

    useEffect(() => {
        if (!data) return null;

        const labels = [];
        const values = [];

        data.forEach((element) => {
            labels.push(element.stolen_item_day);
            values.push(Number(element.qty));
        });

        GraphicUtils.lineChart(elementId, [['Itens subtraídos', ...values]], labels);
        if (values.length > 0) ReportUtils.createExportableTable(labels, values, `${title}`, null, [`${elementName}`, 'Quantidade']);
    }, [data, elementId, title]);


    return (
        <>
            <div className="chart-report">
                <span className="chart-title">{title}</span>
                <div className="mt-3" id={elementId}></div>
            </div>

            { divisor && (
                <div className="chart-divisor"/>
            )}
        </>
    )

};

export default LineChartContent;